import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import ActiveTickets from './components/ActiveTickets'
import FinishedTickets from './components/FinishedTickets'
import ReportTickets from './components/ReportTickets'
import { ROLE } from '../auth'
import { PrivateRoute } from '../auth/PrivateRoute'
import { TicketCardPage } from '../ticket-card'

const PaymentTicketsPage: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='active'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_CASHIER,
                ROLE.ROLE_SENIOR_CASHIER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_OPERATOR,
                ROLE.ROLE_MATCHING_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <ActiveTickets />
            </PrivateRoute>
          }
        />
        <Route
          path='finished'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_CASHIER,
                ROLE.ROLE_SENIOR_CASHIER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_OPERATOR,
                ROLE.ROLE_MATCHING_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <FinishedTickets />
            </PrivateRoute>
          }
        />
        {/* <Route
          path='report'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_CASHIER,
                ROLE.ROLE_SENIOR_OPERATOR,
              ]}
            >
              <ReportTickets />
            </PrivateRoute>
          }
        /> */}
        {/* Карточка тикета. Роут живёт в своём направлении, компонент общий для обоих типов.
            Роли — те же шесть, что открыты на бэкенде; статический `active` ранжируется выше
            параметра, поэтому `card/` вынесен явно и не спорит со списками. */}
        <Route
          path='card/:token'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_SENIOR_CASHIER,
                ROLE.ROLE_SENIOR_OPERATOR,
                ROLE.ROLE_MATCHING_OPERATOR,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
                ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <TicketCardPage />
            </PrivateRoute>
          }
        />
        <Route index element={<Navigate to='/active' />} />
      </Route>
    </Routes>
  )
}

export default PaymentTicketsPage
